import { parse, stringify } from 'qs';

function typeMatch(param){var url=param.url,type=param.type;try{var allowType=["search","hash"];if(allowType.includes(type.toLowerCase())){var urlObj=new URL(url||location.href);var targetHead="";if(type==="search"){targetHead="?";}else if(type==="hash"){if(urlObj[type]&&urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)){urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0];}else {targetHead="#/?";}}var targetString=urlObj[type].replace(targetHead,"");var targetObj=parse(targetString);return {urlObj:urlObj,targetObj:targetObj,targetHead:targetHead}}else {return false}}catch(err){console.error(err);}}

function addUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,params=param.params;var match=typeMatch({url:url,type:type});if(match){var ref=typeMatch({url:url,type:type}),urlObj=ref.urlObj,targetObj=ref.targetObj,targetHead=ref.targetHead;var finalParamsStr=stringify(Object.assign(targetObj,params));urlObj[type]="".concat(targetHead).concat(finalParamsStr);return urlObj.href}else {return url}}

function addHashParams(param){var url=param.url,params=param.params;return addUrlParams({url:url,type:"hash",params:params})}

function pick(obj,keys){return keys.reduce(function(result,key){if(obj[key]){result[key]=obj[key];}return result},{})}

function getUrlParams(param){var url=param.url,_type=param.type,type=_type===void 0?"search":_type,_params=param.params,params=_params===void 0?[]:_params;var targetObj=typeMatch({url:url,type:type}).targetObj;return pick(targetObj,params)}

export { addHashParams, addUrlParams, getUrlParams };
//# sourceMappingURL=url.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@yxl/open-app/~/@yxl/libs/es/url.js
// module id = dgTI
// module chunks = 3 5 8